import { config } from "@nova/configuration/browser"
import { LngLatCoordinatePair } from "../event/types"

export const w3wAddressPattern = /^\/\/\/[a-z]+\.[a-z]+\.[a-z]+$/i

export const convertFromW3W = async (address: string) => {
    const apiKey = config.get("what3WordsApiKey")
    const words = encodeURIComponent(address.replace("///", ""))
    try {
        const response = await fetch(
            `https://api.what3words.com/v3/convert-to-coordinates?key=${apiKey}&words=${words}&format=json`
        )
        if (!response.ok) {
            console.error(`Failed to get coordinate for w3w address: ${response.status}`)
            return
        }
        const { lng, lat } = (await response.json()).coordinates || {}
        if (typeof lng !== "number" || typeof lat !== "number") return

        const center: LngLatCoordinatePair = [lng, lat]
        return center
    } catch (e) {
        console.error(`Failed to get coordinate for w3w address with error: ${e}`)
    }
}
